<template>
  <div class="page">
    <div class="title-div" ref="title">
      <van-icon name="arrow-left" />
      <span>分期协议签署</span>
      <div class="right-title"></div>
    </div>
    <div class="sign-box" v-show="!showSignaturePad">
      <div class="sign-step">
        <div
          class="step-item"
          :class="getClass(index)"
          v-for="(item, index) in stepList"
          :key="item.num"
        >
          <div class="num-div">
            <div class="line start"></div>
            <div class="num">{{ item.num }}</div>
            <div class="line end"></div>
          </div>
          <div class="text">{{ item.label }}</div>
        </div>
      </div>
      <div class="step-one" v-if="active === 0">
        <div class="content">您已完成首付款支付，请绑定银行卡便于后期扣款</div>
        <van-button type="primary" @click="nextStep"
          >完成分期信息填写</van-button
        >
      </div>
      <div class="step-two" v-if="active === 1">
        <div class="card-div">
          <div class="card-item" v-if="detail.idCardFront">
            <van-image width="100%" height="100" :src="detail.idCardFront" />
            <div>身份证正面</div>
          </div>
          <div class="card-item" v-if="detail.idCardContrary">
            <van-image width="100%" height="100" :src="detail.idCardContrary" />
            <div>身份证反面</div>
          </div>
          <div class="card-item" v-if="detail.bankCardFront">
            <van-image width="100%" height="100" :src="detail.bankCardFront" />
            <div>银行卡正面</div>
          </div>
          <div class="card-item" v-if="detail.bankCardContrary">
            <van-image
              width="100%"
              height="100"
              :src="detail.bankCardContrary"
            />
            <div>银行卡正面</div>
          </div>
        </div>
        <div class="confirm-info">
          <van-cell-group style="width: 100%">
            <van-cell title="客户姓名" :value="detail.customerName" />
            <van-cell title="联系方式" :value="detail.contactPhone" />
            <van-cell title="身份证号" :value="detail.certificateNo" />
            <van-cell title="银行卡号码" :value="detail.bankCardNo" />
            <van-cell title="订单金额" :value="detail.receiveAmount" />
            <van-cell title="首付款" :value="detail.firstPayment" />
            <van-cell title="分期数" :value="detail.instalmentPeriods" />
            <van-cell
              title="分期金额"
              :value="
                (
                  (detail.receiveAmount || 0) - (detail.firstPayment || 0)
                ).toFixed(2)
              "
            />
            <van-cell
              title="每期应还"
              :value="
                (detail.receiveAmount || 0) - (detail.firstPayment || 0) &&
                (
                  ((detail.receiveAmount || 0) - (detail.firstPayment || 0)) /
                  (detail.instalmentPeriods || 1)
                ).toFixed(2)
              "
            />
          </van-cell-group>
          <div class="btn-div">
            <van-button type="primary" class="my-btn" @click="nextStep"
              >下一步</van-button
            >
          </div>
        </div>
      </div>
      <div class="step-three" v-if="active === 2">
        <div id="pdf-viewer" ref="pdfViewer" v-show="pdfUrl">
          <canvas ref="pdfCanvas"></canvas>
        </div>
        <van-empty description="无服务凭证" v-if="!pdfUrl" />
        <div class="bind-button-div">
          <van-button round block @click="showSignaturePad = true"
            >去签字</van-button
          >
          <van-button round block type="info" @click="nextStep()"
            >完成</van-button
          >
        </div>
      </div>
      <div class="step-four" v-if="active === 3">
        <!-- <van-form @submit="onSubmit">
          <van-field
            v-model="form.customerName"
            name="customerName"
            label="持卡人"
            placeholder="持卡人"
          />
          <van-field
            v-model="form.bankCardNo"
            name="bankCardNo"
            label="银行卡号码"
            placeholder="银行卡号码"
            :rules="[{ required: true, message: '请填写银行卡号码' }]"
          />
          <van-field
            v-model="form.bankCode"
            name="bankCode"
            label="开卡银行"
            placeholder="开卡银行"
            readonly
            :rules="[{ required: true, message: '请填写开卡银行' }]"
          >
            <template #input>
              <van-dropdown-menu>
                <van-dropdown-item
                  disabled
                  v-model="form.bankCode"
                  :options="bankCodes"
                  ref="item"
                />
              </van-dropdown-menu>
            </template>
          </van-field>
          <van-field
            v-model="form.contactPhone"
            name="contactPhone"
            label="联系方式"
            placeholder="联系方式"
            :rules="[{ required: true, message: '请填写联系方式' }]"
          />
          <van-field
          v-model="form.code"
          name="code"
          label="验证码"
          placeholder="验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <span class="get-code" @click="getCode">{{time == 60 ? '发送验证码' : time + 's'}}</span>
          </template>
        </van-field>
          <div class="tip">请注意，绑定后不支持重新绑卡。</div>
          <div class="agreement">
            <van-checkbox-group v-model="check">
              <van-checkbox name="a" style="align-items: flex-start"
                >本人已充分阅读、理解并同意<span
                  class="link"
                  @click.stop="toPage('user')"
                  >《用户授权协议》</span
                >，授权中国银联获取本人个人信息，包括姓名、证件类型、证件号码、手机号、所选银行卡</van-checkbox
              >
              <van-checkbox name="b" style="align-items: flex-start"
                >本人已阅读并同意
                <span class="link" @click.stop="toPage('bank')"
                  >《{{ agreementInfo.serviceAgreementTitle }}》</span
                ></van-checkbox
              >
            </van-checkbox-group>
          </div>
          <div class="bind-button-div">
            <van-button round block native-type="button">取消</van-button>
            <van-button round block type="info" native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form> -->
        <bindCard :insuranceNo="insuranceNo" />
      </div>
    </div>
    <div class="signature-pad-div" v-show="showSignaturePad">
      <div ref="signatureTitle" class="signature-title"></div>
      <canvas
        ref="signatureCanvas"
        class="signature-pad"
        @touchstart.prevent
        @touchmove.prevent
      ></canvas>
      <div class="bind-button-div">
        <van-button round block @click="clearSignature()">清除</van-button>
        <van-button round block type="info" @click="uploadSignature()"
          >完成</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import SignaturePad from "signature_pad";
import {
  instalmentInfo,
  instalmentSign,
  receiveCodeDetail,
  sendSmsCode,
  confirmBindBankCard,
  bindBankCard,
  getBankAgreement,
  getSelectBankCode,
  queryContractInfo,
  installmentStep,
  infoConfirm,
  signConfirm,
} from "@/api/sign";
import { getMultPolicy } from "@/api/extendedWarranty";
import bindCard from "./bindCard";

export default {
  name: "SignStep",
  components: { bindCard },
  data() {
    return {
      active: 0,
      time: 60,
      check: [],
      interval: null,
      signaturePad: null,
      showSignaturePad: false,
      form: {
        name: "",
        tel: "",
        idCard: "",
        bank: "",
        bankAccount: "",
        bankAccountName: "",
      },
      stepList: [
        {
          label: "完成首付款",
          num: 1,
        },
        {
          label: "确认分期信息",
          num: 2,
        },
        {
          label: "签署分期协议",
          num: 3,
        },
        {
          label: "绑卡",
          num: 4,
        },
      ],
      insuranceNo: "",
      pdfDoc: null,
      pdfUrl: "",
      detail: {},
      info: {},
      applyOrderNo: "",
      payWay: "",
      agreementInfo: {},
      bankCodes: [],
      stepInfo: {},
    };
  },
  computed: {},
  async mounted() {
    // this.$nextTick(() => {
    //   this.loadPdf();
    // });
    this.insuranceNo = this.$route.query.insuranceNo;
    if (!this.insuranceNo) {
      this.$toast.fail("无保单号，请先生成保单");
      return;
    }
    await this.instalmentInfo();
    await this.installmentStep();
    window.addEventListener("resize", this.onResize);
    this.enableZoom();
    this.receiveCodeDetail();
    // await this.getMultPolicy();
    // this.getBankAgreementFun();
    // this.getSelectBankCode();
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    async installmentStep() {
      let res = await installmentStep({ orderNo: this.insuranceNo });
      this.stepInfo = res;
      if (this.stepInfo.installment == 0) {
        this.$toast.fail("该订单不是分期单");
        setTimeout(() => {
          this.$router.replace({
            path: "/pay/index",
            query: { insuranceNo: this.insuranceNo },
          });
        }, 2000);
        return;
      }
      // 分期步骤 1-待完成付首付款；2-待确认分期信息；3-待签署分期协议；4-待绑定银行卡；9-分期签署已完成。
      if (this.stepInfo.installmentSteps == 1) {
        this.$toast.fail("该分期单还未首付款");
        setTimeout(() => {
          this.$router.replace({
            path: "/pay/index",
            query: { insuranceNo: this.insuranceNo },
          });
        }, 2000);
        return;
      } else if (this.stepInfo.installmentSteps == 2) {
        this.active = 0;
      } else if (this.stepInfo.installmentSteps == 3) {
        this.active = 2;
        this.$nextTick(() => {
          this.loadPdf();
        });
      } else if (this.stepInfo.installmentSteps == 4) {
        this.active = 3;
        // this.$dialog
        //   .alert({
        //     message: "绑定银行卡需要去实名认证",
        //   })
        //   .then(() => {
        //     this.$router.push({
        //       path: "/sign/auth",
        //       query: { insuranceNo: this.insuranceNo },
        //     });
        //   });
      } else if (this.stepInfo.installmentSteps == 9) {
        this.$router.replace({
          path: "/sign/account",
          query: { insuranceNo: this.insuranceNo },
        });
      }
    },
    async infoConfirm() {
      let res = await infoConfirm({ orderNo: this.insuranceNo });
      if (!res.success) {
        this.$toast.fail(res.respMag);
        return;
      }
    },
    async receiveCodeDetail() {
      let res = await receiveCodeDetail({ orderNo: this.insuranceNo });
      if (!res.success) {
        this.$toast.fail(res.msg || res.respMag);
        return;
      }
      this.detail = res.content;
    },
    async getMultPolicy() {
      if (/MicroMessenger/.test(window.navigator.userAgent)) {
        // 微信客户端
        this.payWay = "wxQR";
      } else if (/AlipayClient/.test(window.navigator.userAgent)) {
        // 支付宝客户端
        this.payWay = "alipayQR";
      } else {
        // 其他浏览器
        this.payWay = "quickpassQR";
      }
      const resp = await getMultPolicy({
        insuranceNo: this.insuranceNo,
        payWay: this.payWay,
      });
      if (!resp.success) {
        this.$toast.fail(resp.respMag);
        return;
      }
      this.info = resp?.content || {};
      this.form.customerName = this.info.customerName;
      this.form.bankCardNo = this.info.bankCardNo;
      this.form.bankCode = this.info.bankCode;
      this.form.contactPhone = this.info.contactPhone;

      this.obj = resp.content;
      this.curent = resp.content.periods ? resp.content.periods : 3;
      const info = await queryContractInfo({ insuranceNo: this.insuranceNo });
      if (info.success) {
        this.isPay = info.content.finishPayment;
        this.isSign = info.content.signContract;
        this.isAgreement = info.content.signAgreement;
        // 2022.03.23 去掉契约锁签约功能， 已完成首付并去通联实名的， 直接跳转到完成界面
        if (this.isPay && this.isAgreement) {
          storage.setItem("insuranceNo", this.insuranceNo);
          this.$toast.fail("订单已经完成");
          setTimeout(() => {
            this.$router.push({
              path: "/sign/account",
              query: { insuranceNo: this.insuranceNo },
            });
          }, 2000);
        }
      } else {
        if (!res.success) {
          this.$toast.fail(res.respMag);
          return;
        }
      }
    },
    async getSelectBankCode() {
      const res = await getSelectBankCode();
      if (res.success) {
        const data = JSON.stringify(res.content).replace(/label/g, "text");
        this.bankCodes = JSON.parse(data);
      } else {
        if (!res.success) {
          this.$toast.fail(res.respMag);
          return;
        }
      }
    },
    async instalmentInfo() {
      const res = await instalmentInfo({ orderNo: this.insuranceNo });
      if (res.success) {
        this.pdfUrl = res.content?.contractUrl;
      }
    },
    getBankAgreementFun() {
      if (this.info.bankCode) {
        getBankAgreement({
          bankCode: this.info.bankCode,
        }).then((res) => {
          if (res.success) {
            console.log(res);
            this.agreementInfo = res.content;
          } else {
            if (!res.success) {
              this.$toast.fail(res.respMag);
              return;
            }
          }
        });
      }
    },
    enableZoom() {
      const meta = document.querySelector('meta[name="viewport"]');
      meta.setAttribute("content", "width=device-width, initial-scale=1.0");
    },
    async signInfo() {},
    // 当屏幕大小变化时重新渲染
    onResize() {
      if (this.pdfDoc) {
        this.renderAllPages();
        this.resizeSignatureCanvas();
      }
    },

    // 加载 PDF
    async loadPdf() {
      try {
        console.log(this.pdfUrl, "this.pdfUrl---");
        const response = await fetch(this.pdfUrl, { method: "GET" });
        if (!response.ok) {
          throw new Error("请求失败: " + response.status);
        }

        // 取二进制流（不依赖 Content-Type）
        const arrayBuffer = await response.arrayBuffer();

        // 用 pdf.js 解析
        const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
        this.pdfDoc = await loadingTask.promise;

        // 渲染第一页
        await this.renderAllPages();

        // 初始化签名
        this.initSignaturePad();
      } catch (err) {
        console.error("加载 PDF 失败：", err);
      }
    },

    // 渲染 PDF 指定页面
    // 渲染所有页面
    async renderAllPages() {
      const container = this.$refs.pdfViewer;
      container.innerHTML = ""; // 先清空容器

      for (let pageNum = 1; pageNum <= this.pdfDoc.numPages; pageNum++) {
        const page = await this.pdfDoc.getPage(pageNum);

        const viewport = page.getViewport({ scale: 1 });
        const containerWidth = container.clientWidth;
        const scale = containerWidth / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        // 创建 canvas
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        // 高清屏处理
        const dpr = window.devicePixelRatio || 1;
        canvas.width = scaledViewport.width * dpr;
        canvas.height = scaledViewport.height * dpr;
        canvas.style.width = scaledViewport.width + "px";
        canvas.style.height = scaledViewport.height + "px";

        context.setTransform(dpr, 0, 0, dpr, 0, 0);

        // 渲染页面
        await page.render({
          canvasContext: context,
          viewport: scaledViewport,
        }).promise;

        // 把 canvas 插入到容器里
        container.appendChild(canvas);
      }
    },
    toPage(e) {
      if (e == "user") {
        location.href = this.agreementInfo.authorizationAgreement;
      } else if (e == "bank") {
        location.href = this.agreementInfo.serviceAgreement;
      }
    },
    // 初始化签名板
    initSignaturePad() {
      this.resizeSignatureCanvas();
      this.signaturePad = new SignaturePad(this.$refs.signatureCanvas, {
        backgroundColor: "#fff",
        penColor: "black",
      });
    },

    // 根据屏幕宽度调整签名区域
    resizeSignatureCanvas() {
      const canvas = this.$refs.signatureCanvas;
      const containerWidth = this.$refs.title.clientWidth;

      canvas.width = containerWidth - 32;
      canvas.height = 200;

      if (this.signaturePad) {
        this.signaturePad.clear(); // 调整后清空签名
      }
    },
    // 清除签名
    clearSignature() {
      this.signaturePad.clear();
    },
    // 上传签名
    async uploadSignature() {
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        this.$toast.fail("请先签名");
        return;
      }
      this.$dialog
        .confirm({
          title: "提交签名",
          message: `是否提交该客户签名信息`,
        })
        .then(async () => {
          this.showSignaturePad = false;
          this.nextStep();
          const base64Data = this.signaturePad.toDataURL("image/png");
          const blob = this.base64ToBlob(base64Data);

          const formData = new FormData();
          formData.append("signImage", blob, "signature.png");
          formData.append("orderNo", this.insuranceNo);
          console.log(formData);
          let res = await instalmentSign(formData);
          if (res.success) {
            this.$toast(res.respMag || res.msg || "提交成功");
            return true;
          } else {
            this.$toast.fail(res.respMag || res.msg || "提交失败");
            return false;
          }
        });
    },
    base64ToBlob(base64) {
      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    getClass(index) {
      let classname = "";
      if (index == this.active) {
        classname = "active";
      }
      if (index < this.active) {
        classname = "finish";
      }
      return classname;
    },
    async nextStep() {
      if (this.active == 0) {
        this.active++;
      } else if (this.active == 1) {
        let res = await infoConfirm({ orderNo: this.insuranceNo });
        if (res.success) {
          this.active++;
          this.$nextTick(() => {
            this.loadPdf();
          });
        } else {
          this.$toast.fail(res.msg);
        }
      } else if (this.active == 2) {
        if (!this.signaturePad || this.signaturePad.isEmpty()) {
          this.$toast.fail("请先签名");
          return;
        }
        let res = await signConfirm({ orderNo: this.insuranceNo });
        if (res.success) {
          this.active++;
          // this.$dialog
          //   .alert({
          //     message: "绑定银行卡需要去实名认证",
          //   })
          //   .then(() => {
          //     this.$router.push({
          //       path: "/sign/auth",
          //       query: { insuranceNo: this.insuranceNo },
          //     });
          //   });
        } else {
          if (!res.success) {
            this.$toast.fail(res.respMag);
            return;
          }
        }
      } else if (this.active == 3) {
        // this.$router.push({ path: '/sign/auth', query: { insuranceNo: this.insuranceNo } })
      }
      window.scrollTo(0, 0);
    },
    async onSubmit(values) {
      console.log("submit", values);
      const params = {
        bodyNo: this.info.bodyNo,
        applyOrderNo: this.applyOrderNo,
        verCode: this.form.code,
        invoiceAddress: "",
      };
      const res = await confirmBindBankCard(params);
      if (!res.success) {
        this.$toast.fail(res.respMag);
        return;
      }
    },
    async getCode() {
      const params = {
        bodyNo: this.info.bodyNo,
        bankCardNo: this.info.bankCardNo,
        bankCode: this.info.bankCode,
        bankCardHolder: this.info.customerName,
        cardCheck: 6,
        authorizationAgreement: 1,
        serviceAgreement: 1,
      };
      const res = await bindBankCard(params);
      if (res.success) {
        this.$message.info("手机验证码已经发送！");
        this.applyOrderNo = res.content.applyOrderNo;
        this.interval = setInterval(() => {
          this.time--;
          if (this.time <= 0) {
            this.time = 60;
            clearInterval(this.interval);
          }
        }, 1000);
      } else {
        this.disabled = false;
        this.$message.error(res.respMag);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  font-size: 16px;
  padding-bottom: 100px;
  .sign-box {
    margin-top: 44px;
  }
  .btn-div {
    position: fixed;
    left: 0;
    bottom: 16px;
    width: 100%;
    padding: 16px;
    .my-btn {
      width: 100%;
    }
  }
  .title-div {
    position: fixed;
    z-index: 50;
    background-color: #ffffff;
    top: 0;
    left: 0;
    height: 44px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    font-size: 16px;
    border-bottom: 1px solid #d7d7d7;
  }
  .signature-pad-div {
    position: fixed;
    z-index: 10;
    background-color: #ffffff;
    width: 100%;
    top: 44px;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    padding-bottom: 44px;
    .signature-title {
      width: 100%;
    }
    .signature-pad {
      border: 1px solid #ccc;
      border-radius: 16px;
      background: #fff;
      margin: 0 16px;
    }
    .bind-button-div {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 16px;
    }
  }
  .sign-step {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    .step-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .num-div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 16px;
        width: 100%;
        .line {
          flex: 1;
          height: 2px;
          background: #999999;
        }
        .num {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 2px solid #999999;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #999999;
        }
      }
      .text {
        color: #999999;
        font-size: 12px;
        text-align: center;
      }
    }
    .step-item:first-child {
      .start {
        visibility: hidden;
      }
    }
    .step-item:last-child {
      .end {
        visibility: hidden;
      }
    }
    .finish {
      .num-div {
        .line {
          background-color: #2878ff;
        }
        .num {
          border-color: #2878ff;
          color: #2878ff;
        }
      }
      .text {
        color: #2878ff;
      }
    }
    .active {
      .num-div {
        .line {
          background-color: #2878ff;
        }
        .num {
          border-color: #2878ff;
          background: #2878ff;
          color: #ffffff;
        }
      }
      .text {
        color: #000000;
      }
    }
  }
  .step-one {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .content {
      color: #000000;
      font-size: 14px;
      height: 200px;
      margin: 16px;
      padding: 16px;
      border: 1px solid #797979;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 32px;
    }
  }
  .step-two {
    .card-div {
      display: flex;
      flex-wrap: wrap;
      .card-item {
        flex: 0 0 50%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
      }
    }
  }
  .step-four {
    .get-code {
      color: #2878ff;
    }
    .tip {
      color: #d9001b;
      font-size: 12px;
      padding: 0 16px;
      margin-bottom: 16px;
      margin-top: 4px;
    }
    .agreement {
      font-size: 12px;
      padding: 16px;
    }
  }
  .bind-button-div {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    position: fixed;
    left: 0;
    bottom: 16px;
    width: 100%;
  }
  .link {
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
